import { Component, OnInit } from '@angular/core';
import { TableSettingService, Column } from '@src/app/shared/services/table.setting.service';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from '@src/app/shared/components/toaster/toaster.service';


@Component({
    selector: 'app-export-columns-settings',
    templateUrl: './export-columns-settings.component.html',
    styleUrls: ['./export-columns-settings.component.scss'],
    host: {
        class: 'app-export-columns-settings'
    },
    standalone: false
})
export class ExportColumnsSettingsComponent implements OnInit {

  TableSettingService = TableSettingService;
  columns: TableColumnsInternal[] = [];

  salesValues: string[] = [];
  retailsValues: string[] = [];
  cardOrdersValues: string[] = [];
  itemsValues: string[] = [];
  inventoriesValues: string[] = [];
  shipmentsValues: string[] = [];
  customersValues: string[] = [];
  usersValues: string[] = [];

  constructor(
    private tableSettingService: TableSettingService,
    private translate: TranslateService,
    private toasterService: ToasterService) { }

  async ngOnInit() {
    this.tableSettingService.initExports();
    await this.tableSettingService.getAllTablesDefaultsSettings();
    this.setDefaultColumns(TableSettingService.SalesTableName);
    this.setDefaultColumns(TableSettingService.RetailsTableName);
    this.setDefaultColumns(TableSettingService.CardOrdersTableName);
    this.setDefaultColumns(TableSettingService.ItemsTableName);
    this.setDefaultColumns(TableSettingService.InventoriesTableName);
    this.setDefaultColumns(TableSettingService.ShipmentsTableName);
    this.setDefaultColumns(TableSettingService.CustomersTableName);
    this.setDefaultColumns(TableSettingService.UsersTableName);
  }

  public getColumns(tableName: string): Column[] {
    return this.columns.find(x => x.key == tableName)?.columns ?? [];
  }

  private setDefaultColumns(tableName: string) {
    const values = this.tableSettingService.getExportDefaultsSettings(tableName);
    this.columns.push({ key: tableName, columns: values });
    values.forEach(column => {
      if (!column.hide) {
        switch (tableName) {
          case TableSettingService.SalesTableName:
            this.salesValues.push(column.field);
            break;
          case TableSettingService.RetailsTableName:
            this.retailsValues.push(column.field);
            break;
          case TableSettingService.CardOrdersTableName:
            this.cardOrdersValues.push(column.field);
            break;
          case TableSettingService.ItemsTableName:
            this.itemsValues.push(column.field);
            break;
          case TableSettingService.InventoriesTableName:
            this.inventoriesValues.push(column.field);
            break;
          case TableSettingService.ShipmentsTableName:
            this.shipmentsValues.push(column.field);
            break;
          case TableSettingService.CustomersTableName:
            this.customersValues.push(column.field);
            break;
          case TableSettingService.UsersTableName:
            this.usersValues.push(column.field);
            break;
        }
      }
    });
  }

  initForm() { }

  updateModulesSettings() {
    for (let index = 0; index < this.columns.length; index++) {
      const tableName = this.columns[index]?.key ?? '';
      const columns = this.columns[index]?.columns ?? [];

      columns.forEach(column => {
        switch (tableName) {
          case TableSettingService.SalesTableName:
            column.hide = this.salesValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.RetailsTableName:
            column.hide = this.retailsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.CardOrdersTableName:
            column.hide = this.cardOrdersValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ItemsTableName:
            column.hide = this.itemsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.InventoriesTableName:
            column.hide = this.inventoriesValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.ShipmentsTableName:
            column.hide = this.shipmentsValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.CustomersTableName:
            column.hide = this.customersValues.find(v => v == column.field) == null;
            break;
          case TableSettingService.UsersTableName:
            column.hide = this.usersValues.find(v => v == column.field) == null;
            break;
        }
      });
      this.tableSettingService.saveTableSettings(tableName, columns, true);
    }

    const title = this.translate.instant('SYSTEM_SETTINGS.NOTIFICATIONS.TOAST_TITLE_SETTINGS_SAVED');
    const message = this.translate.instant('SYSTEM_SETTINGS.NOTIFICATIONS.TOAST_SUCCESS_MESSAGE_SETTINGS_SAVED');
    this.toasterService.show('success', title, message);
  }
}

export class TableColumnsInternal {
  key?: string;
  columns?: Column[]
}

export class ColumnsInternal {
  key?: string;
  columns?: string[];
}
